const warehouseObjectToWarehouseRequest = (object) => {
    return {
        id: object.id,
        name: object.name,
        code: object.code,
        contact_first_name: object.contactFirstName,
        contact_last_name: object.contactLastName,
        contact_middle_name: object.contactMiddleName,
        contact_phone: object.contactPhone,
        contact_email: object.contactEmail,
        postal_code: object.postalCode,
        state_province: object.stateProvince,
        street1: object.street1,
        street2: object.street2,
        street3: object.street3,
        city_locality: object.cityLocality,
        country_code: object.countryCode,
    };
};

const warehouseResponseToWarehouseObject = (response) => {
    return {
        id: response.id,
        user_id: response.user_id,
        created_at: response.created_at,
        name: response.name,
        code: response.code,
        contactFirstName: response.contact_first_name,
        contactLastName: response.contact_last_name,
        contactMiddleName: response.contact_middle_name,
        contactPhone: response.contact_phone,
        contactEmail: response.contact_email,
        postalCode: response.postal_code,
        stateProvince: response.state_province,
        street1: response.street1,
        street2: response.street2,
        street3: response.street3,
        cityLocality: response.city_locality,
        countryCode: response.country_code,
    };
};

export { warehouseResponseToWarehouseObject, warehouseObjectToWarehouseRequest };
